/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppWithAccounts } from '../../models/app-with-accounts';

export interface AppControllerFindAppWithAccounts$Params {
  appId: string;
}

export function appControllerFindAppWithAccounts(http: HttpClient, rootUrl: string, params: AppControllerFindAppWithAccounts$Params, context?: HttpContext): Observable<StrictHttpResponse<AppWithAccounts>> {
  const rb = new RequestBuilder(rootUrl, appControllerFindAppWithAccounts.PATH, 'get');
  if (params) {
    rb.path('appId', params.appId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppWithAccounts>;
    })
  );
}

appControllerFindAppWithAccounts.PATH = '/app/appWithAccounts/{appId}';
